module.exports = "/assets/data/0a9cb487b7eaaf7d89d464cf0e03835c-PL24.data.json";